// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Header p[data-v-d6761fd2]{text-align:left;padding-bottom:.3125rem}.Header p span[data-v-d6761fd2]{white-space:normal}body[dir=rtl] .Header p[data-v-d6761fd2]{text-align:right}.Header p[data-v-d6761fd2]{margin:0}", ""]);
// Exports
module.exports = exports;
